var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.most_recent_message != null)?_c('div',[_c('div',{staticClass:"alert_container"},[_c('div',{staticClass:"alert"},[_vm._v(" "+_vm._s(_vm.most_recent_message)+" "),_c('a',{on:{"click":_vm.onClickView}},[_vm._v("view")])])]),_c('m-other-conversations-more-dialog',{ref:"more-dialog"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }